import LinkWithText from 'components/link-with-text/LinkWithText';

import { ILinkWithTextList } from 'source/NFR.types';

const LinkWithTextList: React.FC<ILinkWithTextList> = ({ links }) => {
  return (
    <div className="link-with-text-list">
      {links?.map(linkWithText => (
        <LinkWithText key={linkWithText.text} {...linkWithText} />
      ))}
    </div>
  );
};

LinkWithTextList.displayName = 'LinkWithTextList';

export default LinkWithTextList;
